import { Navigate, Outlet } from 'react-router-dom';
import { useAuthentication } from 'src/features/authentication/context';
import { useGetBillingStatusQuery } from 'src/hooks/reactQueryApiHooks';
import { ACCOUNT_BILLING_INFORMATION_PATH } from '../config';
import { LoadingElement } from './LoadingElement';

export const BillingAdminGuard = () => {
  const { customerId, isBillingAdminForCustomer } = useAuthentication();
  const isBillingAdmin = isBillingAdminForCustomer(customerId.value ?? '');
  const { billingInformationStatus, isLoading } = useGetBillingStatusQuery({
    customerId: customerId.value ?? '',
    enabled: isBillingAdmin,
  });

  if (!!customerId.value && isLoading) return <LoadingElement />;

  if (
    billingInformationStatus?.billingConfigurationRequired &&
    isBillingAdmin &&
    !billingInformationStatus?.billingConfigured
  ) {
    return (
      <Navigate to={`${ACCOUNT_BILLING_INFORMATION_PATH}?customerId=${customerId.value}`} replace />
    );
  }

  return <Outlet />;
};
